import { useMerchantUrlUtils } from './useMerchantUrlUtils';

export const useMerchantSlugMaybeStatic = (merchantSlug: MaybeRef<string>) => {
	const { hasMerchantStaticUrl } = useMerchantUrlUtils();

	const originalMerchantSlug = toRef(merchantSlug);

	const merchantSlugMaybeStatic = computed(() => {
		if (originalMerchantSlug.value && hasMerchantStaticUrl(originalMerchantSlug.value)) {
			return 'c';
		}

		return originalMerchantSlug.value;
	});

	return merchantSlugMaybeStatic;
};
